import { EmobilitySettings } from '@containers/index';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './index.scss';

interface Props {
    onSuccess: () => void;
}

export const EmobilitySmartChargingEvSettingsPrompt: FC<Props> = ({
    onSuccess,
}) => {
    const { t } = useTranslation();

    return (
        <div className="c-smart-charging__settings-manual-car">
            <EmobilitySettings
                centerText
                text={t(
                    'In order for smart charging modes to work, please enter a few details about your car.',
                )}
                title={t('Your EV settings')}
                buttonText={t('Save and Continue')}
                onSuccess={onSuccess}
                isGridxFlow
                isManualConnectCar
            />
        </div>
    );
};

export default EmobilitySmartChargingEvSettingsPrompt;
